// extracted by mini-css-extract-plugin
module.exports = {"hidden":"FadeInUp_hidden__5wk8q","shown":"FadeInUp_shown__5Du20"};